<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-text-field
                  name="companyName"
                  label="Company Name"
                  v-model="supplier.companyName"
                  type="text"
                  :rules="rules.companyNameRules"
                ></v-text-field>
              </v-flex>
            <v-flex sm12>
                <v-text-field
                  name="address"
                  label="Address"
                  v-model="supplier.address"
                  type="text"
                  :rules="rules.addressRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="phone"
                  label="Phone No."
                  v-model="supplier.phone"
                  type="text"
                  :rules="rules.phoneRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="email"
                  label="Email"
                  v-model="supplier.email"
                  type="text"
                  :rules="rules.emailRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="contactPerson"
                  label="Contact Person"
                  v-model="supplier.contactPerson"
                  type="text"
                  :rules="rules.contactPersonRules"
                ></v-text-field>
              </v-flex>

              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addSupplierProduct()"
                  >
                    Add Product
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs3>Code</v-flex>
                  <v-flex xs3>Name</v-flex>
                  <v-flex>Status</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(supplierProduct, index) in supplier.productList"
                  :key="index"
                >
                  <v-flex xs3>
                    <v-text-field
                      placeholder="Select the code"
                      v-model="supplierProduct.productCode"
                      @click.stop="showProducts(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="supplierProduct.productName"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      placeholder="Name"
                      readonly
                      :rules="rules.productNameRules"
                    ></v-text-field>
                  </v-flex>

                <v-flex sm3 v-if="supplierProduct.id">
                    <v-switch v-model="supplierProduct.statusFlag"></v-switch>
                  </v-flex>
                  <v-flex sm3 v-if="!supplierProduct.id">
                    <v-btn
                      icon
                      v-if="index === 0"
                      @click="removeSupplierProduct(index,supplierProduct)"
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <v-btn icon v-else @click="removeSupplierProduct(index,supplierProduct)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>

                </v-layout>
                <v-layout row wrap>
                  <v-btn color="success" @click="addSupplierCurrency()">
                    Add Currency
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex sm3>Code</v-flex>
                  <v-flex>Status</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(supplierCurrency, index) in supplier.currencyList"
                  :key="'supplier'+index"
                >
                  <v-flex sm3>
                    <v-autocomplete
                    v-model=" supplier.currencyList[index].currencyCode"
                      :loading="showAutocompleteLoading"
                      :items="currencyList"
                      label="Select currency"
                      menu-props="auto"
                      item-text="code"
                      @change="prop => addCurrency(index, prop)"
                      :readonly="supplierCurrency.id?true:false"
                      :rules="[v => !!v || 'Currency is required',]"
                      return-object
                    ></v-autocomplete>
                  </v-flex>


                  <v-flex sm3 v-if="supplierCurrency.id">
                    <v-switch v-model="supplierCurrency.statusFlag"></v-switch>
                  </v-flex>
                  <v-flex sm3 v-if="!supplierCurrency.id">
                    <v-btn
                      icon
                      v-if="index === 0"
                      @click="removeSupplierCurrency(index,supplierCurrency)"
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <v-btn icon v-else @click="removeSupplierCurrency(index,supplierCurrency)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- final message dialog -->
    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code, selectedIndex), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { supplierService } from "../../services/supplier-service";
import { warehouseService } from "../../services/warehouse-service";
import { Supplier, SupplierCurrency } from "../../models/model";
import { SupplierProduct} from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { SupplierFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
import { currencyService } from "../../services/currency-service";
export default {
  name: "SupplierDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Supplier",
        disabled: false,
        to: "suppliers"
      },
      {
        text: "Supplier Detail",
        disabled: true
      }
    ],
    warehouseId: "",
    fromWarehouseId: "",
    toWarehouseId: "",
    issueDate: "",
    fromWarehouseName: "",
    responseError: "",
    currencyList: [],
    showAutocompleteLoading: false,
    messageDialogBox: false,
    supplier: new Supplier(),
    supplierProduct: new SupplierProduct(),
    supplierCurrency: new SupplierCurrency(),
    oldSupplier: new Supplier(),
    saveLoading: false,
    statusList: [],
    warehouseList: [],
    productList: [],
    status: "DRAFT",
    rules: new SupplierFormRules(),
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    }
  },
  created() {
    this.getCurrencies();
    const id = this.$route.params.id;
    if (id == "new") {
      // new stockTransfer
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      this.addSupplierProduct();
      this.addSupplierCurrency();
    } else {
      this.getSupplierDetail(id);
    }
  },
  methods: {
    getCurrencies() {
      currencyService
        .getCurrencyByStatus('ACTIVE')
        .then(res => {
          this.currencyList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        supplierService
          .saveSupplier(this.supplier)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },
      getSupplierDetail(id) {
      supplierService
        .getSupplierDetail(id)
        .then(res => {
          this.supplier = res.data;
          // deep copy
          this.oldSupplier = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },
    getWarehouses() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          this.warehouseList = res.data;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    addCurrency(index, currency) {
      if(currency!= null){
      this.supplier.currencyList[index].currencyId = currency.id;
      this.supplier.currencyList[index].currencyCode = currency.code;
      console.log(JSON.stringify(this.supplier.currencyList));
      }
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    addSupplierCurrency() {
      //deep copy
      let supplierCurrency = new SupplierCurrency();
      this.supplier.currencyList.push(supplierCurrency);
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.supplier.id) {
        this.supplier = new Supplier();
        this.addSupplierProduct();
        this.addSupplierCurrency();
      } else {
        this.supplier = Object.assign({}, this.oldSupplier);
      }
    },
    removeSupplierCurrency(index) {
      this.$delete(this.supplier.currencyList, index);
    },
    goBack() {
      this.$router.push("/suppliers");
    },
    addSupplierProduct() {
      // deep copy
      let sti = JSON.parse(JSON.stringify(this.supplierProduct));

      this.supplier.productList.push(sti);
    },
    removeSupplierProduct(index, supplierProductId) {
      if (supplierProductId) {
        // add delete stockTransfer item id
        if (!this.supplier.deleteSupplierProductIds) {
          this.supplier.deleteSupplierProductIds = [];
        }
        this.supplier.deleteSupplierProductIds.push(supplierProductId);
      }
      this.$delete(this.supplier.productList, index);
    },
    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.supplier.productList[index].productId = product.id;
      this.supplier.productList[index].productCode = product.code;
      this.supplier.productList[index].productName = product.name;
      console.log(JSON.stringify(this.supplier.productList));
    }
  }
};
</script>

